// extracted by mini-css-extract-plugin
export default {"eight_img":"index_eight_img_aWzKw","box_list":"index_box_list_pepWj","bg":"index_bg_jkp9h","info":"index_info_dlrMM"};